<template>
    <div class="c-kv" :style="rootStyle">
        <span :style="keyStyle">{{ k }}</span>
        <span :style="valStyle">{{ v }}</span>
    </div>
</template>

<script>
import { C_INK, C_MUTED, TAG_RED_DEEP } from './tokens';

export default {
    name: 'CKv',
    props: {
        k: { type: String, required: true },
        v: { type: [String, Number], required: true },
        // When true, the value renders in the brand-deep-red tone (used
        // for "Outstanding" balances and other emphasised numbers).
        accent: { type: Boolean, default: false },
    },
    computed: {
        rootStyle() {
            return { display: 'flex', justifyContent: 'space-between', gap: '12px' };
        },
        keyStyle() {
            return { color: C_MUTED };
        },
        valStyle() {
            return { color: this.accent ? TAG_RED_DEEP : C_INK, fontWeight: 600 };
        },
    },
};
</script>
